<template>
  <el-radio-group v-bind="$attrs" v-model="selectValue">
    <slot />
  </el-radio-group>
</template>

<script>
export default {
  name: 'RtRadioGroup',
  props: {
    value: String | Number | Boolean
  },
  data() {
    return {
      selectValue: this.value
    };
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// rtRadioGroup.vue?4582db1c